const GENERAL_STYLE = {
    MAIN_TEXT_COLOR: '#2b5672',
    LINK_TEXT_COLOR: '#3899ec',
    MAIN_TEXT_SIZE: '14px',
    DIVIDER_COLOR: '#d9e1e8',
    EDIT_SLIDE_WIDTH_RIGHT_PANEL: '330px',
    // EDIT_SLIDE_WIDTH_RIGHT_PANEL: '285px',
    EDIT_SLIDE_WIDTH_ROOT_CONTAINER: '1044px'
}

export default GENERAL_STYLE;